import script from "./ReadOnlyCompornent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReadOnlyCompornent.vue?vue&type=script&lang=ts&setup=true"

import "./ReadOnlyCompornent.vue?vue&type=style&index=0&id=155134b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155134b9"]])

export default __exports__